module.exports = __webpack_public_path__ + "static/media/excel.1ad23785.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/excel.png
// module id = 234
// module chunks = 0